function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 16.781c-2.607 0-4.718-1.95-4.912-4.42L3.482 9.67a11.03 11.03 0 00-1.262 1.846c-.16.304-.16.664 0 .969a11.067 11.067 0 009.78 5.89c.925 0 1.817-.133 2.677-.347l-1.783-1.333a5.06 5.06 0 01-.894.086zm10.787 1.93l-3.8-2.838a11.056 11.056 0 002.793-3.389c.16-.304.16-.664 0-.969A11.067 11.067 0 0012 5.625c-1.77.002-3.51.432-5.064 1.252L2.563 3.612a.566.566 0 00-.772.093l-.675.84a.519.519 0 00.096.745l20.225 15.098a.564.564 0 00.772-.093l.675-.84a.518.518 0 00-.097-.745zm-6.315-4.716l-1.35-1.008c.113-.318.173-.651.178-.987a3.111 3.111 0 00-1.286-2.546 3.351 3.351 0 00-2.884-.516c.207.272.32.6.32.937a1.493 1.493 0 01-.053.332l-2.53-1.889A5 5 0 0112 7.218c1.313 0 2.572.504 3.5 1.4A4.697 4.697 0 0116.95 12c0 .718-.182 1.388-.478 1.996z"
});

function SvgPasswordEyeHideinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgPasswordEyeHideinline;